import COINS, {
  NATIVE,
  ETH_TOKENS,
  COIN_DATA,
  TOKEN_STANDARD,
} from './COINS'
import ENV from './ENV'
import SERVICES from './SERVICES'
import NETWORKS from './NETWORKS'


export default {
  COINS,
  NATIVE,
  ETH_TOKENS,
  COIN_DATA,
  TOKEN_STANDARD,

  ENV,
  SERVICES,
  NETWORKS,
}
